import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./style.css";

const DEFAULT_HREF =
  "https://wa.me/5542933008907?text=Ol%C3%A1!%20Tudo%20bem%3F%0AGostaria%20de%20efetuar%20uma%20reserva%20no%20Hotel%20Marechal%20Express.%0APoderia%2C%20por%20favor%2C%20me%20informar%20sobre%20a%20disponibilidade%20e%20os%20procedimentos%20para%20confirmar%20a%20reserva%3F";

export default function WhatsAppFloat({ href = DEFAULT_HREF }) {
  return (
    <a
      href={href}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Reservar ou falar com o hotel pelo WhatsApp"
    >
      <FaWhatsapp className="whatsapp-float__icon" aria-hidden />
    </a>
  );
}
